import { Link } from 'react-router-dom';
import { categories } from '@/mocks/homepage';

export default function CategorySection() {
  const iconColors = [
    'bg-primary-100/70 text-primary-600',
    'bg-accent-100/70 text-accent-600',
    'bg-secondary-100/70 text-secondary-600',
    'bg-primary-100/70 text-primary-600',
    'bg-accent-100/70 text-accent-600',
    'bg-secondary-100/70 text-secondary-600',
  ];

  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            丰富麻将玩法，随心选择
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            涵盖全国各地主流麻将玩法，无论你喜欢哪种规则，这里都能满足你
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((cat, idx) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70 hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-start gap-4">
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${iconColors[idx % iconColors.length]} shrink-0 transition-transform duration-300 group-hover:scale-110`}>
                  <i className={`${cat.icon} text-xl`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1.5">
                    <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900">
                      {cat.name}
                    </h3>
                    <span className="text-[10px] px-2 py-0.5 bg-accent-100/70 text-accent-700 rounded-full font-medium whitespace-nowrap">
                      热度 {cat.popularity}%
                    </span>
                  </div>
                  <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                    {cat.description}
                  </p>
                  <div className="flex items-center gap-3 text-xs text-foreground-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-user-line"></i>
                      {cat.playerCount}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-speed-line"></i>
                      {cat.difficulty}
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}